import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

interface EmspBoInvoiceListInvoiceNumberCellProps
  extends CellContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['invoiceNumber']
  > {}

export const EmspBoInvoiceListInvoiceNumberCell = (
  props: EmspBoInvoiceListInvoiceNumberCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.EMSP_BO_INVOICE.DETAILS, {
            id: row.original.id,
          }),
        )
      }
      fullWidth>
      <Text truncate>{getValue() ?? '-'}</Text>
    </Link>
  );
};
